// With firebase

import { useState, useEffect, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import ProductCard from '../../components/product-card/product-card.component';

import { selectCategoriesMap } from '../../store/categories/category.selector';

import './category.styles.scss';

function Category() {
  const { category } = useParams();
  const categoriesMap = useSelector(selectCategoriesMap);
  const [products, setProducts] = useState(categoriesMap[category]);

  useEffect(() => {
    setProducts(categoriesMap[category]);
  }, [category, categoriesMap]);

  return (
    <Fragment>
      <h2 className="category-title">{category.toUpperCase()}</h2>
      <div className="category-container">
        {products &&
          products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
      </div>
    </Fragment>
  );
}

////////////////////////////////////////////////////
// Without firebase

// import { useContext, useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';

// import ProductCard from '../../components/product-card/product-card.component';

// import { CategoriesContext } from '../../contexts/categories.context';

// import './category.styles.scss';

// function Category() {
//   const { category } = useParams();
//   const { categoriesMap } = useContext(CategoriesContext);
//   const [products, setProducts] = useState(categoriesMap[category]);
//   console.log(category);

//   useEffect(() => {
//     setProducts(
//       categoriesMap.filter((el) => el.title.toLowerCase() === category)[0].items
//     );
//   }, [category, categoriesMap]);

//   return (
//     <div className="category-container">
//       {products &&
//         products.map((product) => (
//           <ProductCard key={product.id} product={product} />
//         ))}
//     </div>
//   );
// }

export default Category;
